module.exports = __webpack_public_path__ + "img/fcb.9278aefc.jpg";